// Elenco paesi in italiano (per il campo Nazionalità): evita scritture diverse dello stesso paese
export const PAESI = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antartide",
  "Antigua e Barbuda",
  "Antille Francesi",
  "Arabia Saudita",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrein",
  "Bangladesh",
  "Barbados",
  "Belgio",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bielorussia",
  "Birmania",
  "Bolivia",
  "Bosnia ed Erzegovina",
  "Botswana",
  "Brasile",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambogia",
  "Camerun",
  "Canada",
  "Capo Verde",
  "Cechia",
  "Ciad",
  "Cile",
  "Cina",
  "Cipro",
  "Città del Vaticano",
  "Colombia",
  "Comore",
  "Congo",
  "Congo (Rep. Dem.)",
  "Corea del Nord",
  "Corea del Sud",
  "Costa Rica",
  "Costa d'Avorio",
  "Croazia",
  "Cuba",
  "Curaçao",
  "Danimarca",
  "Dominica",
  "ESwatini",
  "Ecuador",
  "Egitto",
  "El Salvador",
  "Emirati Arabi Uniti",
  "Eritrea",
  "Estonia",
  "Etiopia",
  "Figi",
  "Filippine",
  "Finlandia",
  "Francia",
  "Gabon",
  "Gambia",
  "Georgia",
  "Georgia del Sud e Isole Sandwich Meridionali",
  "Germania",
  "Ghana",
  "Giamaica",
  "Giappone",
  "Gibilterra",
  "Gibuti",
  "Giordania",
  "Grecia",
  "Grenada",
  "Groenlandia",
  "Guadeloupa",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea Equatoriale",
  "Guinea-Bissau",
  "Guyana",
  "Guyana francese",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Irlanda",
  "Islanda",
  "Isola Bouvet",
  "Isola Norfolk",
  "Isola di Jersey",
  "Isola di Man",
  "Isola di Natale",
  "Isole Aland",
  "Isole Cayman",
  "Isole Cocos e Keeling",
  "Isole Cook",
  "Isole Falkland o Isole Malvine",
  "Isole Far Oer",
  "Isole Heard e McDonald",
  "Isole Marianne Settentrionali",
  "Isole Marshall",
  "Isole Pitcairn",
  "Isole Salomone",
  "Isole Tokelau",
  "Isole Turks e Caicos",
  "Isole Vergini Britanniche",
  "Isole Vergini americane",
  "Isole minori esterne degli Stati Uniti d'America",
  "Israele",
  "Italia",
  "Kazakistan",
  "Kenya",
  "Kirghizistan",
  "Kiribati",
  "Kosovo",
  "Kuwait",
  "Laos",
  "Lesotho",
  "Lettonia",
  "Libano",
  "Liberia",
  "Libia",
  "Liechtenstein",
  "Lituania",
  "Lussemburgo",
  "Macao",
  "Macedonia del Nord",
  "Madagascar",
  "Malawi",
  "Maldive",
  "Malesia",
  "Mali",
  "Malta",
  "Marocco",
  "Martinica",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Messico",
  "Micronesia",
  "Moldavia",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Mozambico",
  "Namibia",
  "Nauru",
  "Nepal",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norvegia",
  "Nuova Caledonia",
  "Nuova Zelanda",
  "Paesi Bassi",
  "Paesi Bassi caraibici",
  "Pakistan",
  "Palau",
  "Palestina",
  "Panama",
  "Papua Nuova Guinea",
  "Paraguay",
  "Perù",
  "Polinesia Francese",
  "Polonia",
  "Porto Rico",
  "Portogallo",
  "Principato di Monaco",
  "Qatar",
  "Regno Unito",
  "Repubblica Centrafricana",
  "Repubblica Dominicana",
  "Riunione",
  "Romania",
  "Ruanda",
  "Russia",
  "Sahara Occidentale",
  "Saint Kitts e Nevis",
  "Saint Martin",
  "Saint Vincent e Grenadine",
  "Saint-Pierre e Miquelon",
  "Samoa",
  "Samoa Americane",
  "San Marino",
  "Sant'Elena, Ascensione e Tristan da Cunha",
  "Santa Lucia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Siria",
  "Slovacchia",
  "Slovenia",
  "Somalia",
  "Spagna",
  "Sri Lanka",
  "Stati Uniti d'America",
  "Sud Africa",
  "Sudan",
  "Sudan del sud",
  "Suriname",
  "Svalbard e Jan Mayen",
  "Svezia",
  "Svizzera",
  "São Tomé e Príncipe",
  "Tagikistan",
  "Tailandia",
  "Taiwan",
  "Tanzania",
  "Territori Francesi del Sud",
  "Territorio britannico dell'oceano indiano",
  "Timor Est",
  "Togo",
  "Tonga",
  "Trinidad e Tobago",
  "Tunisia",
  "Turchia",
  "Turkmenistan",
  "Tuvalu",
  "Ucraina",
  "Uganda",
  "Ungheria",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Wallis e Futuna",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "oman",
];
